import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/my-booking/$id/')({
  beforeLoad: ({ params }) =>
    redirect({
      to: '/my-booking/$id/view',
      params: {
        id: params.id,
      },
    }),
})
